export default __webpack_public_path__ + "static/media/ESSH16DRBE01.a259d514.mp4";